import React, { useState } from 'react';
import { Button, Form, Input, Row, Col } from 'antd';
import * as productClassService from 'redux/services/productClass';
import { GlobalError } from 'components';
import { handleErrors } from 'Utils/errorHandler';
import { useHistory } from 'react-router-dom';

export default () => {
  const [form] = Form.useForm();
  const [globalErrors, setGlobalErrors] = useState([]);
  const history = useHistory();

  const handleSubmit = values => {
    (async () => {
      try {
        const created = await productClassService.create({ name: values.name, description: values.description });
        history.push(`/catalog/productClass/view/${created.id}`);
      } catch (err) {
        setGlobalErrors(handleErrors(err, history, form));
      }
    })();
  };

  return (
    <div>
      <h2 className="page-title">Add Product Class</h2>
      <GlobalError errors={globalErrors} />
      <Form form={form} onFinish={handleSubmit}>
        <Row gutter={24}>
          <Col md={8} sm={24}>
            <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Name is required.' }]}>
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col md={16} sm={24}>
            <Form.Item name="description" label="Description">
              <Input.TextArea />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col sm={24}>
            <Button type="primary" htmlType="submit">Create</Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
